import {WebApplicationState} from "../types";

export const getPreferenceSelectedStore = (state: WebApplicationState) => state.preference.selectedStore;
export const getPreferenceStores = (state: WebApplicationState) => state.preference.stores;
export const getPreferenceOperation = (state: WebApplicationState) => state.preference.operation;